import { EMPTY_ERROR } from '~/constants/errorCodes';
import { TCompletedForms, TIdentificationForm, TIdentificationStore } from './types';

export const emptyCompletedForms: TCompletedForms = {
  isAdditionalInformationCompleted: false,
  isDocumentsCompleted: false,
  isGeneralInfoCompleted: false,
  isGettingStartedCompleted: false,
  isManagementStructureCompleted: false,
  isManagersAndRepresentativesCompleted: false,
  isOwnershipStructureDTOCompleted: false,
  isPurposeOfBusinessRelationsCompleted: false,
  isRelatedCompaniesCompleted: false,
  isFinancialStateCompleted: false,
  isTaxResidencyAdditionalInformationCompleted: false,
  isFatcaAdditionalInformationCompleted: false,
};

export const initialFormState: TIdentificationForm = {
  additionalInformation: {},
  completedForms: emptyCompletedForms,
  documents: {},
  financialState: {},
  generalInfo: {},
  gettingStarted: {},
  managementStructure: {},
  managersAndRepresentatives: {},
  ownershipStructure: {},
  purposeOfBusinessRelations: {},
  relatedCompanies: {},
  taxResidencyAdditionalInformation: {},
  fatcaAdditionalInformation: {},
};

export const initialIdentificationState: TIdentificationStore = {
  formData: initialFormState,
  formDataBack: null,
  pendingFormDataBack: false,
  isReidentification: false,
  applicationReportForm: null,
  applicationReportTable: null,
  applicationExportToExcel: null,
  applicationReportActionPendingId: null,
  isDisabledDiagramGeneration: false,
  loading: false,
  error: EMPTY_ERROR,
};
